'use strict';

var _ = require('lodash');
var OverridesSaveService = function OverridesSaveService($q, $timeout, restangular, overridesPreparationService) {
  var RETRY_TIME = 50;
  var service = restangular.one('adjustments');
  var requestsInProgress = [];
  function saveOverrides(data, gridId, scenario) {
    if (!(data && data.length)) {
      return $q.when();
    }
    if (requestsInProgress.length > 0) {
      return $timeout(function () {
        return saveOverrides(data, gridId, scenario);
      }, RETRY_TIME, false);
    }
    requestsInProgress.push(gridId);
    var overrides = overridesPreparationService.prepareOverrides(data, gridId, scenario);
    return overrides.reduce(function (accumulatorPromise, override) {
      return accumulatorPromise.then(function (accumulator) {
        return putOverrides(override.domain, override.requestBody).then(function (response) {
          return accumulator.concat(response._embedded.booleanList);
        });
      });
    }, $q.when([]))["finally"](function () {
      _.pull(requestsInProgress, gridId);
    });
  }
  function putOverrides(domain, requestBody) {
    return service.one(_.lowerFirst(domain)).customPUT(requestBody);
  }
  return {
    saveOverrides: saveOverrides,
    putOverrides: putOverrides
  };
};
OverridesSaveService.$inject = ['$q', '$timeout', 'Restangular', 'OverridesPreparationService'];
module.exports = OverridesSaveService;